function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bi_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M-90.5 0H592v512H-90.5z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#bi_svg__a)",
  transform: "translate(84.9) scale(.9375)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00cf00",
  d: "M-178 0l428.8 256L-178 512zm857.6 0L250.8 256l428.8 256z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M-178 0l428.8 256L679.6 0zm0 512l428.8-256 428.8 256z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M679.6 0h-79.9L-178 464.3V512h79.9L679.6 47.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M398.9 256a148 148 0 11-296.1 0 148 148 0 01296 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-178 0v47.7L599.7 512h79.9v-47.7L-98.1 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "red",
  stroke: "#00de00",
  strokeWidth: 3.9,
  d: "M280 200.2l-19.3.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm-64.6 111.6l-19.2.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm130.6 0l-19.2.3-10 16.4-10-16.4-19.1-.4 9.3-16.9-9.3-16.8 19.2-.4 10-16.4 10 16.5 19.2.4-9.4 16.8z"
}));

var SvgBi = function SvgBi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2);
};

export default SvgBi;